import { render, staticRenderFns } from "./PhoneMultiple.vue?vue&type=template&id=3acc53eb&"
import script from "./PhoneMultiple.vue?vue&type=script&lang=js&"
export * from "./PhoneMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports